<template>
  <section class="all-cases-view" id="archive-listing-cases">
    <div class="navbarComponent">
      <div class="container-default">
        <div class="listings-navbar">
          <el-row>
            <el-col :lg="7">
              <ul class="d-flex list-items-group-15 barcode-print">
                <li>
                  <div class="form-element input-with-icon search-input-lg">
                    <el-input
                      placeholder="Search"
                      v-model="search_string"
                      @input="getAutoCompleteCases()"
                      :clearable="true"
                    ></el-input>
                    <span>
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid icon"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
            <el-col :lg="17">
              <ul
                class="d-flex flex-wrap justify-content-end list-items-group-15"
              >
                <li>
                  <div
                    class="form-element search-with-filter-input-without-icon"
                  >
                    <el-select
                      v-model="searchBy"
                      clearable
                      filterable
                      default-first-option
                      :reserve-keyword="false"
                      placeholder="Select Search"
                      @change="clearInputSearch"
                    >
                      <el-option
                        v-for="item in searchOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      />
                    </el-select>
                  </div>
                </li>

                <li v-if="searchBy == 'Patient DOB'">
                  <div class="search-with-date-input">
                    <el-date-picker
                      format="MM-DD-YYYY"
                      v-model="date_of_birth"
                      :disabled-date="disabledDate"
                      @change="fetchCases()"
                      placeholder="Select DOB"
                      :clearable="true"
                    ></el-date-picker>
                  </div>
                </li>
                <li v-else-if="searchBy == 'hospital'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="hospital"
                      placeholder="Select Ordering Facility"
                      filterable
                      default-first-option
                      clearable
                      @change="handleCurrentChange(1)"
                      @focus="fetchAllHospitals"
                      :loading="hospitalsLoading"
                    >
                      <el-option
                        v-for="hospital in hospitalsData.data"
                        :key="hospital"
                        :label="hospital.name"
                        :value="hospital._id"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'ordering_physician'">
                  <div class="form-element search-with-filter-input">
                    <el-select
                      v-model="physician"
                      placeholder="Select"
                      filterable
                      default-first-option
                      clearable
                      @change="handleCurrentChange(1)"
                      @focus="fetchAllPhysicians"
                      :loading="physiciansLoading"
                    >
                      <el-option
                        v-for="physician in physiciansData.data"
                        :key="physician"
                        :label="physician.name"
                        :value="physician._id"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
                <li v-else-if="searchBy == 'case_types'">
                  <div
                    class="form-element search-with-filter-input"
                    v-if="
                      getAuthenticatedUser.user_type == 'LAB_TECHNOLOGIST' &&
                      getAuthenticatedUser.allowed_case_types
                    "
                  >
                    <el-select
                      v-model="caseType"
                      placeholder="Select"
                      filterable
                      clearable
                      default-first-option
                      :reserve-keyword="false"
                      @change="handleCurrentChange(1)"
                    >
                      <el-option
                        v-for="caseType in getUserBasedCaseTypes(caseTypes)"
                        :key="caseType"
                        :label="caseType.label"
                        :value="caseType.value"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                  <div class="form-element search-with-filter-input" v-else>
                    <el-select
                      v-model="caseType"
                      placeholder="Select"
                      filterable
                      clearable
                      default-first-option
                      :reserve-keyword="false"
                      @change="handleCurrentChange(1)"
                    >
                      <el-option
                        v-for="caseType in getLabBasedCaseTypes(caseTypes)"
                        :key="caseType"
                        :label="caseType.label"
                        :value="caseType.value"
                      >
                      </el-option>
                    </el-select>
                    <span class="search-icon">
                      <img
                        src="@/assets/images/icons/search-icon-with-bg-red.svg"
                        alt="icon"
                        class="img-fluid"
                      />
                    </span>
                  </div>
                </li>
              </ul>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <div class="container-default" style="padding-top: 0">
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <el-table
            :data="getAllCases.data"
            height="calc(100vh - 200px)"
            @sort-change="onChangeSort"
            :default-sort="{
              prop: orderBy,
              order: orderType == 'asc' ? 'ascending' : 'descending',
            }"
          >
            <el-table-column
              label="ACCESSION ID"
              prop="accession_id"
              fixed="left"
              min-width="160"
              sortable="custom"
            >
              <template #default="scope">
                <div class="name-accession cursor">
                  <span
                    id="accession-no-cursor"
                    @click="goToCaseView(scope.row._id)"
                  >
                    {{ scope.row.accession_id }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="Case Type"
              min-width="135px"
              fixed="left"
              prop="case_types"
              sortable="custom"
            >
              <template #default="scope">
                <div
                  class="case-type"
                  v-if="scope.row.case_types && scope.row.case_types.length > 1"
                >
                  <el-dropdown>
                    <span class="case-data-type">
                      {{ getCaseTypes(scope.row.case_types)[0] }}

                      <img
                        src="@/assets/images/case-type-arrow.svg"
                        alt="icon"
                      />
                    </span>

                    <template #dropdown>
                      <el-dropdown-menu class="case-type-dropdown">
                        <el-dropdown-item
                          class="cases-view"
                          v-for="(caseType, index) of getCaseTypes(
                            scope.row.case_types
                          )"
                          :key="index"
                        >
                          {{ caseType }}
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
                <div v-else class="case-type">
                  <span class="case-data-type">
                    {{ getCaseTypes(scope.row.case_types)[0] }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="PATIENT NAME"
              prop="patient_info.first_name"
              min-width="200"
              fixed="left"
              sortable="custom"
            >
              <template #default="scope">
                <div v-if="scope.row.patient_info">
                  <el-button
                    placement="top"
                    class="title-on-hover"
                    :title="convertToUppercase(getPatientNameByInfo(scope.row.patient_info))"
                    @click="
                      copyTitle(getPatientNameByInfo(scope.row.patient_info))
                    "
                  >
                    <span class="text-center ordering_facility-value">{{
                      convertToUppercase(getPatientNameByInfo(scope.row.patient_info))
                    }}</span>
                  </el-button>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="PATIENT DOB"
              prop="date_of_birth"
              min-width="120"
            >
              <template #default="scope">
                <span
                  v-if="
                    scope.row.patient_info &&
                    scope.row.patient_info.date_of_birth
                  "
                >
                  {{ formatDate(scope.row.patient_info.date_of_birth) }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="ORDERING FACILITIES"
              prop="ordering_facility"
              min-width="300"
            >
              <template #default="scope">
                <div
                  class="table_cell-ellipsis"
                  v-if="scope.row.hospital && scope.row.hospital.name"
                >
                  {{ scope.row.hospital.name }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="PHYSICIAN" prop="physician" min-width="190">
              <template #default="scope">
                <div
                  class="ordering_facility-value"
                  v-if="
                    scope.row.ordering_physician &&
                    scope.row.ordering_physician.name
                  "
                >
                  {{
                    /* scope.row.ordering_physician
                      ? scope.row.ordering_physician.name.includes("Dr")
                        ? scope.row.ordering_physician.name
                        : "Dr " + scope.row.ordering_physician.name
                      : "--" */
                    scope.row.ordering_physician
                      ? scope.row.ordering_physician.name
                      : "--"
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="COLLECTED ON"
              prop="collection_date"
              min-width="140"
              sortable="custom"
            >
              <template #default="scope">
                <div class="d-flex" v-if="scope.row.collection_date">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(
                        scope.row.collection_date,
                        "MM-DD-yyyy"
                      )
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="RECEIVED ON"
              prop="received_date"
              min-width="140"
              sortable="custom"
            >
              <template #default="scope">
                <div class="d-flex" v-if="scope.row.received_date">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.received_date, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="Status" min-width="150" prop="status">
              <template #default="scope">
                <div class="column-status">
                  <span class="el-dropdown-link">
                    <el-tag :type="getStatusType(scope.row.status)">{{
                      scope.row.status
                    }}</el-tag>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="REPORTED ON"
              prop="reported_at"
              min-width="160"
              sortable="custom"
            >
              <template #default="scope">
                <div class="d-flex" v-if="scope.row.reported_at">
                  <div class="date pr-10">
                    {{
                      momentWithTimezone(scope.row.reported_at, "MM-DD-yyyy")
                    }}
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="COVID STATUS"
              prop="covid_status"
              sortable="custom"
              min-width="150"
              v-if="hasCovidCaseType"
            >
              <template v-slot="scope">
                <div class="column-status">
                  <el-dropdown
                    v-if="
                      hasCovid(scope.row) &&
                      scope.row.covid_status &&
                      hasPermission('cases', 'update_covid_status')
                    "
                    class="status-dropdown"
                    @command="
                      (command) =>
                        changeCovidStatus(
                          command,
                          scope.row._id,
                          scope.$index,
                          scope.row.covid_status
                        )
                    "
                    trigger="click"
                  >
                    <span class="el-dropdown-link">
                      <el-tag
                        v-if="scope.row.covid_status != 'RESULT_AWAITED'"
                        :type="getCovidStatusType(scope.row.covid_status)"
                      >
                        {{ scope.row.covid_status }}
                      </el-tag>
                      <p v-else>Result Awaited</p>
                    </span>
                  </el-dropdown>

                  <span
                    v-else-if="hasCovid(scope.row) && scope.row.covid_status"
                  >
                    <el-tag
                      v-if="
                        scope.row.covid_status &&
                        scope.row.covid_status != 'RESULT_AWAITED'
                      "
                      :type="getCovidStatusType(scope.row.covid_status)"
                    >
                      {{ scope.row.covid_status }}
                    </el-tag>
                    <p v-else>Result Awaited</p>
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="action"
              label="Actions"
              width="90"
              fixed="right"
            >
              <template v-slot="scope">
                <ul class="listings__action-buttons">
                  <li @click="goToCaseView(scope.row._id)">
                    <el-button class="view-button" title="View Case">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/view-icon.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/view-inactive.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                  <li
                    @click="onRestore(scope.row._id)"
                    v-if="hasPermission('cases', 'restore')"
                  >
                    <el-button class="view-button" title="Restore Case">
                      <img
                        class="action-active"
                        src="@/assets/images/icons/actions/restore-icon-danger.svg"
                        alt="icon"
                      />
                      <img
                        class="action-inactive"
                        src="@/assets/images/icons/actions/restore-icon-danger.svg"
                        alt="icon"
                      />
                    </el-button>
                  </li>
                </ul>
                <el-row> </el-row>
              </template>
            </el-table-column>
          </el-table>
          <div class="listings listings__pagination">
            <el-pagination
              v-model:currentPage="page"
              v-model:page-size="pageSize"
              :page-sizes="[25, 50, 75, 100]"
              layout=" prev, pager, next, jumper, sizes ,total"
              :total="getAllCases.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import caseConstants from "@/config/constants/caseConstants";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import { casesSearchOptions } from "@/config/constants/searchConstants";
import FilterHelper from "@/mixins/FilterHelper";
import caseDataHelper from "@/mixins/caseDataHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  data() {
    return {
      disabledDate: (time) => {
        return time.getTime() > Date.now();
      },
      caseTypeMap: caseConstants.CASE_TYPE_MAP,
      searchOptions: casesSearchOptions,
      // searchByKey: ["PatientName", "accession_id"],
      scrollPosition: null,
      page: 1,
      pageSize: 25,
      loading: false,
      search_string: "",
      searchBy: "",
      hospital: "",
      orderBy: "",
      orderType: "",
      caseType: "",
      physician: "",
      date_of_birth: "",
      caseTypes: caseConstants.CASE_TYPES_DATA,
      hospitalsData: {},
      physiciansData: {},
      hospitalsLoading: false,
      physiciansLoading: false,
    };
  },
  mixins: [UserPermissionsHelper, FilterHelper, caseDataHelper],
  computed: {
    ...mapGetters("cases", ["getAllCases", "getRestoreCaseStatus"]),
    ...mapGetters("errors", ["getErrors", "getError"]),

    ...mapGetters("hospitals", ["getAllHospitals"]),
    ...mapGetters("physicians", ["getAllPhysicians"]),
    // isSearchByInput() {
    //   return this.searchByKey.indexOf(this.searchBy) != -1 ? true : false;
    // },
    getCovidStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "POSITIVE") {
          return "danger";
        } else if (status == "NEGATIVE") {
          return "success";
        } else if (status == "INCONCLUSIVE") {
          return "info";
        } else {
          return "";
        }
      };
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "COMPLETE") {
          return "success";
        } else if (status == "TEST_REPORTS") {
          return "warning";
        } else if (status == "ARCHIVED") {
          return "danger";
        } else {
          return "";
        }
      };
    },

    getCaseTypes() {
      return (caseTypes) => {
        return (caseTypes || []).map((e) => this.caseTypeMap[e]);
      };
    },
    hasCovidCaseType() {
      if (
        this.searchBy == "case_types" &&
        (this.caseType == "COVID" || this.caseType == "COVID_FLU")
      ) {
        return true;
      }
      if (
        this.$route.query.selectedSearchBy == "case_types" &&
        (this.$route.query.selectedCase == "COVID" ||
          this.$route.query.selectedCase == "COVID_FLU")
      ) {
        return true;
      }
      return false;
    },
  },
  async mounted() {
    this.setQueryParamsData();
    await this.fetchCases();
  },
  methods: {
    updateQueryParams(params) {
      let selectedParams = {
        selectedPage: params.page,
        selectedCase: params.case_type,
        selectedHospital: params.hospital,
        selectedDateOfBirth: params.date_of_birth,
        selectedPhysician: params.ordering_physician,
        selectedString: params.search_string,
        selectedPageSize: params.limit,
        selectedOrderBy: params.order_by,
        selectedOrderType: params.order_type,
        selectedCaseId: this.$route.query.selectedCaseId,
        selectedSearchBy: this.searchBy || undefined,
      };
      this.updateQueryParam(this.$route.name, selectedParams);
    },
    setQueryParamsData() {
      if (this.$route.query) {
        this.page = this.$route.query.selectedPage
          ? parseInt(this.$route.query.selectedPage)
          : 1;
        this.pageSize = this.$route.query.selectedPageSize
          ? parseInt(this.$route.query.selectedPageSize)
          : 25;
        if (this.$route.query.selectedString) {
          this.search_string = this.$route.query.selectedString;
        }
        if (this.$route.query.selectedCase) {
          this.caseType = this.$route.query.selectedCase;
        }
        if (this.$route.query.selectedCaseId) {
          this.selectedCaseId = this.$route.query.selectedCaseId;
        }
        if (this.$route.query.selectedSearchBy) {
          this.searchBy = this.$route.query.selectedSearchBy;
        }
        if (this.$route.query.selectedPhysician) {
          this.fetchAllPhysicians();
          this.physician = this.$route.query.selectedPhysician;
        }
        if (this.$route.query.selectedHospital) {
          this.fetchAllHospitals();
          this.hospital = this.$route.query.selectedHospital;
        }
        if (this.$route.query.selectedDateOfBirth) {
          this.date_of_birth = this.$route.query.selectedDateOfBirth;
        }
        if (this.$route.query.selectedOrderBy) {
          this.orderBy = this.$route.query.selectedOrderBy;
        }
        if (this.$route.query.selectedOrderType) {
          this.orderType = this.$route.query.selectedOrderType;
        }
      }
    },
    async fetchAllPhysicians() {
      this.physiciansLoading = true;
      await this.$store.dispatch("physicians/fetchAllPhysicians", {
        get_all: true,
      });
      this.physiciansData = JSON.parse(JSON.stringify(this.getAllPhysicians));
      this.physiciansLoading = false;
    },
    async fetchAllHospitals() {
      this.hospitalsLoading = true;
      await this.$store.dispatch("hospitals/fetchAllHospitals", {
        get_all: true,
      });
      this.hospitalsData = JSON.parse(JSON.stringify(this.getAllHospitals));
      this.hospitalsLoading = false;
    },

    async onRestore(id) {
      this.$confirm("Are you sure to Restore case?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.restoreCase(id);
      });
    },
    async restoreCase(caseId) {
      this.loading = true;
      await this.$store.dispatch("cases/restoreArchivedCase", caseId);
      if (this.getRestoreCaseStatus) {
        successNotification("Case restored Successfully");
        await this.fetchCases(this.page);
      } else {
        errorNotification("An Error occured while restoring.");
      }
      this.loading = false;
    },
    goToCaseView(caseId) {
      this.$router.push({
        name: "CaseView",
        params: { case_id: caseId },
        query: { ...this.$route.query, redirectRoute: this.$route.name },
      });
    },
    hasCovid(caseData) {
      return (
        caseData.case_types.indexOf("COVID") > -1 ||
        caseData.case_types.indexOf("COVID_FLU") > -1
      );
    },
    onChangeSort({ order, prop }) {
      if (order && prop) {
        this.orderBy = prop;
        this.orderType = order == "ascending" ? "asc" : "desc";
      } else {
        this.orderBy = "created_at";
        this.orderType = "DESC";
      }
      this.fetchCases();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchCases();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchCases();
    },
    clearInputSearch() {
      if (
        this.hospital ||
        this.physician ||
        this.date_of_birth ||
        this.caseType
      ) {
        this.hospital = "";
        this.physician = "";
        this.date_of_birth = "";
        this.caseType = "";
        this.isSearchByInput = "";
        this.page = 1;
        this.fetchCases(1);
      }
    },
    getAutoCompleteCases() {
      setTimeout(() => {
        this.page = 1;
        this.fetchCases();
      }, 600);
    },
    prepareParams() {
      const params = {
        page: this.page,
        limit: this.pageSize,
        status: ["ARCHIVED"],
      };
      if (this.search_string) {
        params.search_string = this.search_string;
      }
      if (this.date_of_birth) {
        const date_of_birth = moment(this.date_of_birth).format("YYYY-MM-DD");

        params.date_of_birth = date_of_birth;
      }
      if (this.hospital) {
        params.hospital = this.hospital;
      }
      if (this.caseType) {
        params.case_type = this.caseType;
      }
      if (this.physician) {
        params.ordering_physician = this.physician;
      }
      if (this.orderBy && this.orderType) {
        params.order_by = this.orderBy;
        params.order_type = this.orderType;
      }

      return params;
    },
    async fetchCases() {
      try {
        this.loading = true;
        let params = this.prepareParams();
        await this.$store.dispatch("cases/fetchAllCases", params);
        this.updateQueryParams(params);
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style lang="scss">
#archive-listing-cases {
  .stickyNavbar {
    padding-bottom: 5px !important;
    .container-default {
      padding-top: 0;
      padding-bottom: 5px;
    }
  }
}
</style>
